<template>
  <div class="failureAccess">
    <i class="iconfont icon-shibai-icon icon"></i>
    <p class="title">无法评估</p>
    <div class="resonContent">
      <p class="resonTitle">评估结果</p>
      <div class="content">
        <p class="headerReson"> 1、未获取到该企业发票数据，请检查是否已安装客户端；</p>
        <p class="linkContent">
          下载地址：http://zhushou.efapiao.com/download-efpzs/efpzs/eInvoiceBoxFinance.exe（在开票电脑上下载）
          <span
            class="vanButton handeCopy"
            :aria-label="copyText"
            @click="handeCopy"
            color="#FF6538"
            type="primary"
          >点击复制</span>
        </p>
      </div>
    </div>
    <div class="orderInfo">
      <div class="shell">
        <p class="list firstListStyle">
          <span class="fl">企业名称</span><span class="fr ">{{corpName}}</span>
        </p>
        <p class="list">
          <span class="fl">企业税号</span><span class="fr ">
            {{taxNo}}
          </span>
        </p>
      </div>
    </div>
    <Button
      text="返回首页"
      :type="danger"
      class="nextStep"
      :click="gohomePage"
    />
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast } from 'vant';
import Button from '@/components/Button.vue';

export default {
  name: 'UnableAccess',
  data() {
    return {
      corpName: '',
      taxNo: '',
      isLoading: false,
      copyText: 'http://zhushou.efapiao.com/download-efpzs/efpzs/eInvoiceBoxFinance.exe',
    };
  },

  created() {
    const {
      corpName, taxNo,
    } = this.$router.currentRoute.query;
    this.corpName = corpName;
    this.taxNo = taxNo;
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
  methods: {
    handeCopy() {
      const clipboard = new Clipboard('.handeCopy', {
        text(trigger) {
          return trigger.getAttribute('aria-label');
        },
      });
      clipboard.on('success', () => {
        Toast('复制成功');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        // 不支持复制 console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy();
      });
    },
    gohomePage() {
      this.$router.push('/supermarket/v2');
    },
  },
  components: {
    Button,
  },


};
</script>
<style scoped>
.failureAccess {
  padding-top: 100px;
  background: #fff;
  height: calc(100vh);
  box-sizing: border-box;
}
.icon {
  color: #f5514a;
  font-size: 60px;
}
.reason {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 15px;
  color: #7c7c7c;
  font-size: 12px;
  text-align: left;
  background: #f8f9fb;
}
.none {
  display: none;
}
.seeDetail {
  color: #f55646;
}
.title {
  color: #1c2438;
  margin: 20px 0 0;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}

.sepLineShell {
  box-sizing: border-box;
  width: 100%;
  margin-top: 40px;
  padding-right: 15px;
  padding-left: 15px;
}
.sepLine {
  width: 100%;
  height: 1px;
  background: #dfdede;
}

.retry {
  float: left;
  width: 158px;
  margin-right: 8px;
  padding-right: 0;
  padding-left: 0;
}
.shell {
  box-sizing: border-box;
  width: 100%;
  padding-top: 15px;
  padding-right: 15px;
  padding-left: 15px;
}
.list {
  height: 44px;
  margin: 0;
  padding: 0;
  color: #495060;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
}
.fl {
  float: left;
  line-height: 22px;
  font-weight: 400;
}
.fr {
  float: right;
  width: 70%;
  line-height: 22px;
  text-align: right;
  font-weight: 400;
}
.reEvaluate {
  width: 345px;
  margin-top: 80px;
  color: #fff;
  font-size: 14px;
}
.teleInfo {
  color: #a2abb7;
  font-size: 12px;
  letter-spacing: 0;
  text-align: center;
}
.item {
  color: #fff;
}
.vanButton {
  background-color: none !important;
  border: none;
  color: rgb(255, 101, 56);
  padding: 0;
  margin: 0;
  height: 22px;
  float: right;
}
.reasonStyle {
  word-break: break-all;
}
.resonTitle {
  margin: 0;
  padding: 50px 0 12px 15px;
  color: #495060;
  font-weight: 400;
  text-align: left;
}
.content {
  background: #f8f9fb;
  padding: 12px 15px;
  padding-bottom: 20px;
  box-sizing: border-box;
}
.content p {
  margin: 0;
  text-align: left;
}
.headerReson {
  padding: 0;
}
.linkContent {
  word-break: break-all;
}
.firstListStyle {
  padding-top: 10px;
}
.nextStep >>> button {
  background: #ff6538;
  border-radius: 8px;
  color: #fff;
}
.content p {
  font-size: 14px;
  color: #7c7c7c;
}
</style>
